export default {
  path: '/tickets',
  name: 'tickets',
  component: () => import('../components/ticket/Layout'),
  redirect: { name: 'TicketList' },
  meta: {
    breadcrumb: 'ticket.tickets',
  },
  children: [
    {
      name: 'TicketList',
      path: '',
      component: () => import('../views/ticket/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'TicketCreate',
      path: 'new',
      component: () => import('../views/ticket/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'TicketCreateByClient',
      path: 'customer/:parent',
      component: () => import('../views/ticket/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'TicketUpdate',
      path: ':id/edit',
      component: () => import('../views/ticket/Update'),
      meta: {
        breadcrumb: 'ticket.ticket',
      },
    },
    {
      name: 'TicketShow',
      path: ':id',
      component: () => import('../views/ticket/Show'),
      meta: {
        breadcrumb: 'ticket.ticket',
      },
    },
    {
      name: 'Ticket',
      path: ':parent',
      component: () => import('../components/ticketaction/Layout'),
      meta: {
        breadcrumb: 'ticket.ticket',
      },
      children: [
        {
          name: 'TicketactionShow',
          path: ':id',
          component: () => import('../views/ticketaction/Show'),
          meta: {
            breadcrumb: 'ticket.ticketaction',
          },
        },
        {
          name: 'TicketactionUpdate',
          path: ':id/edit',
          component: () => import('../views/ticketaction/Update'),
          meta: {
            breadcrumb: 'ticket.ticketaction',
          },
        },
        {
          name: 'TicketactionCreate',
          path: 'new',
          component: () => import('../views/ticketaction/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
